import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/app/[locale]/partners/[slug]/partner.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/node_modules/next/dist/client/link.js");
